import { render } from "./Deans.vue?vue&type=template&id=23032565&scoped=true"
import script from "./Deans.vue?vue&type=script&lang=js"
export * from "./Deans.vue?vue&type=script&lang=js"

import "./Deans.vue?vue&type=style&index=0&id=23032565&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23032565"

export default script